    import React, { useState, useEffect } from 'react';

    import Sidebar from '../Sidebar/Sidebar';
    import toastr from 'toastr';
    import 'toastr/build/toastr.min.css'; 
    import { useNavigate } from 'react-router-dom';
    import $, { data } from 'jquery';
    import '../pages.css';

    const DownloadLeads = () => {
    const baseURL = process.env.REACT_APP_BASE_URL;
    const navigate = useNavigate();

    const [builderTypes, setBuilderTypes] = useState([]);
    const [selectedBuilderType, setSelectedBuilderType] = useState('');
    const [errors, setErrors] = useState({});
    const [isChecked, setIsChecked] = useState(false);
    const [responseData, setResponseData] = useState(null);
    const [fromDate, setFromDate] = useState('');
    const [toDate, setToDate] = useState('');
    const [fileFormat, setFileFormat] = useState('excel');


    useEffect(() => {
        const fetchData = async () => {
          try {
            $('#loading').show();
            const accessToken = localStorage.getItem('access_token') || sessionStorage.getItem('access_token');
      
            if (!accessToken) {
              navigate('/');
              console.error('Access token not found in localStorage');
              $('#loading').hide();
              return;
            }
      
            const response = await fetch(`${baseURL}/get_ads/`, {
              headers: {
                Authorization: `Token ${accessToken}`,
                'Cache-Control': 'no-cache', // Include access token in the headers
              },
            });
      
            if (!response.ok) {
              $('#loading').hide();
            }
      
            const data = await response.json();
            if (data && data.data) {
              setBuilderTypes(data.data);
              $('#loading').hide();
            }
          } catch (error) {
            console.error('Error fetching builder types:', error);
            setErrors({ selectedBuilderType: 'Error fetching builder types' });
            $('#loading').hide();
          }
        };
      
        fetchData();
      }, []);
      

      const handleFromDateChange = async (event) => {
        setFromDate(event.target.value);
        try {
          $('#loading').show();
          const accessToken = localStorage.getItem('access_token') || sessionStorage.getItem('access_token');
      
          if (!accessToken) {
            navigate('/');
            console.error('Access token not found in localStorage');
            $('#loading').hide();
            return;
          }
      
          const response = await fetch(`${baseURL}/get_lead_count/`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Authorization: `Token ${accessToken}`,
              'Cache-Control': 'no-cache', // Include access token in the headers
            },
            body: JSON.stringify({
              adName: selectedBuilderType,
              fromDate: fromDate,
              toDate: event.target.value,
              checkboxValue: isChecked,
            }),
          });
      
          if (!response.ok) {
            $('#loading').hide();
          }
      
          const data = await response.json();
          console.log(data);
          setResponseData(data);
          $('#loading').hide();
          // Handle any other logic based on the response
        } catch (error) {
          console.error('Error fetching data:', error);
          $('#loading').hide();
          // Handle error state or display an error message
        }
      };
      
    
      const handleToDateChange = async (event) => {
        setToDate(event.target.value);
      
        try {
          $('#loading').show();
          const accessToken = localStorage.getItem('access_token') || sessionStorage.getItem('access_token');
      
          if (!accessToken) {
            navigate('/');
            console.error('Access token not found in localStorage');
            $('#loading').hide();
            return;
          }
      
          const response = await fetch(`${baseURL}/get_lead_count/`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Authorization: `Token ${accessToken}`,
              'Cache-Control': 'no-cache', // Include access token in the headers
            },
            body: JSON.stringify({
              adName: selectedBuilderType,
              fromDate: fromDate,
              toDate: event.target.value,
              checkboxValue: isChecked,
            }),
          });
      
          if (!response.ok) {
            $('#loading').hide();
          }
      
          const data = await response.json();
          console.log(data);
          setResponseData(data);
          $('#loading').hide();
          // Handle any other logic based on the response
        } catch (error) {
          console.error('Error fetching data:', error);
          $('#loading').hide();
          // Handle error state or display an error message
        }
      };
      
    const handleCheckboxChange = () => {
        setIsChecked(!isChecked);
    };

    // Define handleBuilderTypeChange function to update selectedBuilderType
    const handleBuilderTypeChange = (event) => {
        setSelectedBuilderType(event.target.value);
    };

    const handleSendButtonClick = async (event) => {
        event.preventDefault();         
      
        try {
          $('#loading').show();
          const accessToken = localStorage.getItem('access_token') || sessionStorage.getItem('access_token');
      
          if (!accessToken) {
            navigate('/');
            console.error('Access token not found in localStorage');
            $('#loading').hide();
            return;
          }
      
          const response = await fetch(`${baseURL}/send_lead_file/`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Authorization: `Token ${accessToken}`,
              'Cache-Control': 'no-cache', // Include access token in the headers
            },
            body: JSON.stringify({
              adName: selectedBuilderType,
              fromDate: fromDate,
              toDate: toDate,
              checkboxValue: isChecked,
              // Other necessary data for the API call
            }),
          });
      
          if (response.ok) {
            toastr.success('File sent successfully');
            $('#loading').hide();
          } else {
            toastr.error('Data not found in the specified range');
            $('#loading').hide();
          }
      
          // Handle success logic after sending the file
        } catch (error) {
          console.error('Error sending file:', error);
          $('#loading').hide();
          // Handle error state or display an error message
        }
      };
      
    
    

      const handleDownloadButtonClick = async (event) => {
        event.preventDefault();
        try {
          $('#loading').show();
          const accessToken = localStorage.getItem('access_token') || sessionStorage.getItem('access_token');

          if (!accessToken) {
            navigate('/');
            console.error('Access token not found in localStorage');
            $('#loading').hide();
            return;
          }

          const endpoint = `${baseURL}/download_pdf_file/`;

          const response = await fetch(endpoint, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Authorization: `Token ${accessToken}`,
              'Cache-Control': 'no-cache',
            },
            body: JSON.stringify({
              adName: selectedBuilderType,
              fromDate: fromDate,
              toDate: toDate,
              downloadType: fileFormat,
            }),
          });

          if (!response.ok) {
            $('#loading').hide();
            return;
          }

          const contentDisposition = response.headers.get('Content-Disposition');
          const fileNameMatch = contentDisposition && contentDisposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/);
          const defaultFileName = fileFormat === 'pdf' ? 'leads.pdf' : 'leads.xlsx';
          const fileName = fileNameMatch ? fileNameMatch[1].replace(/['"]/g, '') : defaultFileName;

          const mimeType = fileFormat === 'pdf' ? 'application/pdf' : 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
          const arrayBuffer = await response.arrayBuffer();
          const blob = new Blob([arrayBuffer], { type: mimeType });
          const url = window.URL.createObjectURL(blob);

          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', fileName);
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          window.URL.revokeObjectURL(url);
          $('#loading').hide();
        } catch (error) {
          console.error('Error downloading file:', error);
          $('#loading').hide();
        }
      };
      
    
    
    return (
        <div className="container-fluid tms-page">
          <div className="row flex-nowrap">
            <div className="col-auto p-0"><Sidebar /></div>
            <main className="tms-main">
              <div className="tms-page-header">
                <div>
                  <h2 className="tms-page-title">Download Leads</h2>
                  <div className="tms-page-subtitle">Export leads as Excel or PDF</div>
                </div>
              </div>

              <div id="loading">
                <div className="loader">
                  <div className="spinner-border text-primary" role="status">
                    <span className="sr-only">Loading...</span>
                  </div>
                  <div className="loader-text">Loading...</div>
                </div>
              </div>

              <div className="tms-card" style={{ maxWidth: 600 }}>
                <form encType="multipart/form-data">
                  <div className="tms-form-group">
                    <label className="tms-label">Page Name <span>*</span></label>
                    <select
                      name="ad_name"
                      id="ad_name"
                      className="tms-select"
                      required
                      value={selectedBuilderType}
                      onChange={handleBuilderTypeChange}
                    >
                      <option value="">Select Ad</option>
                      {builderTypes.map((item) => (
                        <option key={item.id} value={item.id}>
                          {item.builder_name}
                        </option>
                      ))}
                    </select>
                    {errors.selectedBuilderType && <div className="tms-error">{errors.selectedBuilderType}</div>}
                  </div>

                  <div className="tms-form-group">
                    <label className="tms-label">From Date <span>*</span></label>
                    <input
                      type="date"
                      id="startdate"
                      name="startdate"
                      className="tms-input"
                      placeholder="Please Enter Start date"
                      required
                      onChange={handleFromDateChange}
                    />
                  </div>

                  <div className="tms-form-group">
                    <label className="tms-label">To Date <span>*</span></label>
                    <input
                      type="date"
                      id="enddate"
                      name="enddate"
                      className="tms-input"
                      placeholder="Please Enter End date"
                      required
                      onChange={handleToDateChange}
                    />
                  </div>

                  {responseData && (
                    <div className="tms-form-group">
                      <label className="tms-label">Lead Count</label>
                      <input type="text" className="tms-input" value={responseData.data} readOnly />
                    </div>
                  )}

                  <div className="tms-form-group" style={{ display: 'flex', gap: 24 }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                      <input
                        type="radio"
                        name="fileFormat"
                        id="formatExcel"
                        value="excel"
                        checked={fileFormat === 'excel'}
                        onChange={() => setFileFormat('excel')}
                      />
                      <label className="tms-label" htmlFor="formatExcel" style={{ marginBottom: 0 }}>Excel</label>
                    </div>
                    <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                      <input
                        type="radio"
                        name="fileFormat"
                        id="formatPdf"
                        value="pdf"
                        checked={fileFormat === 'pdf'}
                        onChange={() => setFileFormat('pdf')}
                      />
                      <label className="tms-label" htmlFor="formatPdf" style={{ marginBottom: 0 }}>PDF</label>
                    </div>
                  </div>

                  <button
                    className="tms-btn-primary"
                    onClick={handleDownloadButtonClick}
                    disabled={!selectedBuilderType || !fromDate || !toDate}
                  >
                    Download
                  </button>
                </form>
              </div>
            </main>
          </div>
        </div>
    );
    }

    export default DownloadLeads;
